import Alert from "react-s-alert";

export const errorAlert = (message) => {
  Alert.error(`<h4>${message}</h4>`, {
    position: "top-right",
    effect: "bouncyflip",
    beep: true,
    html: true,
    timeout: 3000,
    offset: 35,
  });
}

export const successAlert = (message) => {
  Alert.success(`<h4>${message}</h4>`, {
    position: "top-right",
    effect: "bouncyflip",
    beep: true,
    html: true,
    timeout: 3000,
    offset: 35,
  });
}
